import React, { useEffect, useRef, useState } from 'react';
import * as R from "ramda";
import { useDispatch } from 'react-redux';
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router';


import { FetchAllTeleconseillers } from '../../actions/funecap/teleconseiller';
import { LoadingState } from '../../_common/loadingState';
import * as Loadings from '../../constants/loadings/funecap/teleconseillers';


import { TeleconseillersMain } from './main';
// import { ClientsDetail } from './detail';

export const Teleconseillers = ({ teleconseillersReducer, partner, etablissement }) => {

	const dispatch = useDispatch();
	const searchQuery = useLocation();

	const pageQuery = new URLSearchParams(searchQuery.search);
	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let roles = pageQuery.get('roles');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	roles = R.isNil(roles) ? "PARTNER,ETABLISSEMENT" : roles;
	sortBy = R.isNil(sortBy) ? "creationDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;

	const [pageSearch, setPageSearch] = useState(search);
	const renderRef = useRef(false);
	const history = useHistory();

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push("/funecap/teleconseillers");
			return;
		}

		//pageNumber, searchTerm,roles, sortByTerm, sortDesc
		dispatch(FetchAllTeleconseillers(page, search, roles, sortBy, sortDesc, partner.id));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery.search, history.location]);


	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};

		if (R.isEmpty(pageSearch)) {
			history.push(`/funecap/teleconseillers?page=${1}${roles !== "" ? "&roles=" + roles : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${routerQuery.sortDesc !== "" ? "&sortDesc=" + routerQuery.sortDesc : ""}${!R.isNil(partner)? "&partnerId=" + partner.id : ""}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(FetchAllTeleconseillers(page, pageSearch, roles, sortBy, sortDesc, partner.id));
		}, 1000);


		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);



	if (teleconseillersReducer.isLoading.includes(Loadings.FETCHING_TELECONSEILLERS) && R.isNil(teleconseillersReducer.items)) {
		return <LoadingState />;
	}


	if (R.isNil(teleconseillersReducer.items)) {
		return '';
	}

	const routerQuery = {
		page,
		search,
		roles,
		sortBy,
		sortDesc,
	};


	return (
		<Switch>
			<Route exact path="/funecap/teleconseillers" >
				<TeleconseillersMain teleconseillersReducer={teleconseillersReducer} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} partner={partner} etablissement={etablissement} />
			</Route>
			{/* <Route path="/backoffice/clients/:user" component={ClientsDetail} /> */}
			<Route render={() => {
				return <Redirect exact to="/funecap/teleconseillers" />;
			}} />
		</Switch>
	);

};

